module.exports = __webpack_public_path__ + "img/icon-s2.5a116da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/signStatistics/icon-s2.png
// module id = uti1
// module chunks = 0 4 5 9